<template>
  <BaseSelectModal
    ref="baseModal"
    title="Select Enterprise User"
    endpoint="/enterprise-users"
    :fields="fields"
    search-placeholder="Search by name or email..."
    @selected="handleSelected"
  >
    <template #name="{ item }">
      <td>
        <strong>{{ item.name }}</strong>
      </td>
    </template>

    <template #email="{ item }">
      <td class="text-muted">
        {{ item.email }}
      </td>
    </template>
  </BaseSelectModal>
</template>

<script>
import BaseSelectModal from './BaseSelectModal.vue';

export default {
  name: 'EnterpriseUserSelectModal',
  emits: ['selected'],
  components: {
    BaseSelectModal,
  },
  data() {
    return {
      fields: [
        { key: 'id', label: 'ID', _style: 'width: 50px' },
        { key: 'name', label: 'Name' },
        { key: 'email', label: 'Email' },
        { key: 'actions', label: 'Actions', sorter: false, _style: 'width: 100px;' },
      ],
    };
  },
  methods: {
    open() {
      this.$refs.baseModal.open();
    },

    handleSelected(user) {
      this.$emit('selected', user);
    },
  },
};
</script>
